import moment from "moment"
import Select from 'react-select';
import { FormGroup, Input, Label } from "reactstrap"
import { optionsPropierty } from "../../../../helper/constants";
import { setRUTFormat } from "../../../../shared/utils"
import { isRUTValid } from "../../../../helper/functions";

const PersonalData = ({
  onChangeAddressPersonal,
  onChangeInput,
  optionsEC,
  values
}) => (
  <div className="crm-case-form-container">
    <div>
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="rut">*Rut cliente:</Label>
        <Input
          type="text"
          name="rut"
          id="rut"
          className="newArea"
          disabled={values.editField}
          value={setRUTFormat(values.rut)}
          invalid={!isRUTValid(values.rut)}
          onChange={onChangeInput('rut')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="names">*Nombre cliente</Label>
        <Input
          type="text"
          name="names"
          id="names"
          maxLength="20"
          className="newArea"
          disabled={values.editField}
          value={values.names}
          onChange={onChangeInput('names')}
          required
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="paternalSurname">*Apellido paterno</Label>
        <Input
          type="text"
          name="paternalSurname"
          id="paternalSurname"
          maxLength="20"
          className="newArea"
          disabled={values.editField}
          value={values.paternalSurname}
          onChange={onChangeInput('paternalSurname')}
          required
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="maternalSurname">Apellido materno</Label>
        <Input
          type="text"
          name="maternalSurname"
          id="maternalSurname"
          maxLength="20"
          className="newArea"
          disabled={values.editField}
          value={values.maternalSurname}
          onChange={onChangeInput('maternalSurname')}
        />
      </FormGroup>
    </div>
    <div >
      <Label className="label_autofin" for="birthdate">Fecha nacimiento:</Label>
      <FormGroup>
        <Input
          type="text"
          name="birthdate"
          id="birthdate"
          maxLength="10"
          className="newArea"
          disabled={true}
          value={values.birthdate && moment(values.birthdate).format('DD/MM/YYYY')}
          onChange={onChangeInput('birthdate')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="email">*Correo:</Label>
        <Input
          className="mb-2 newArea"
          maxLength="50"
          disabled={values.editField}
          onChange={onChangeInput('email')}
          value={values.email}
          type="email"
          placeholder="correo"
          required
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="phone">*Telefono:</Label>
        <Input
          className="mb-2 newArea"
          maxLength="9"
          minLength="9"
          disabled={values.editField}
          onChange={onChangeInput('phone')}
          value={values.phone}
          type="phone"
          placeholder="telefono"
          required
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="nacionality">Nacionalidad:</Label>
        <Input
          type="text"
          name="nacionality"
          id="nacionality"
          maxLength="20"
          className="newArea"
          disabled={true}
          value={values.nacionality}
          onChange={onChangeInput('nacionality')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="rut">Estado civil:</Label>
        <Select
          options={optionsEC}
          type="text"
          isDisabled={values.editField}
          placeholder="seleccionar"
          name="civilStatus"
          isClearable="true"
          id="civilStatus"
          value={values.civilStatus}
          onChange={onChangeInput('civilStatus')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="profile">Calle</Label>
        <Input
          className="mb-2 newArea"
          disabled={values.editField}
          onChange={onChangeAddressPersonal('street')}
          value={values?.address?.street || ''}
          placeholder="Calle"
          maxLength="50"
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="profile">Región</Label>
        <Select
          options={values.regions}
          type="text"
          name="region"
          id="region"
          isDisabled={values.editField}
          placeholder="seleccionar"
          value={values?.address?.region || ''}
          onChange={onChangeAddressPersonal('addressRegion')}
          isClearable="true"
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup>
        <Label className="label_autofin" for="profile">Comuna</Label>
        <Select
          options={values?.address?.coptions || []}
          type="text"
          isDisabled={values.editField}
          name="commune"
          id="commune"
          placeholder="seleccionar"
          noOptionsMessage={() => 'Seleccione la región'}
          value={values?.address?.commune || ''}
          isClearable="true"
          onChange={onChangeAddressPersonal('addressCommune')}
          required
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="haveProperty">¿Posee propiedades?</Label>
        <Select
          options={optionsPropierty}
          type="text"
          placeholder="seleccionar"
          name="haveProperty"
          id="haveProperty"
          isDisabled={values.editField}
          value={values.haveProperty}
          onChange={onChangeInput('haveProperty')}
        />
      </FormGroup>
    </div>
    <div >
      <FormGroup style={{ textAlign: 'left' }}>
        <Label className="label_autofin" for="rut">¿Posee vehiculos?</Label>
        <Select
          options={optionsPropierty}
          type="text"
          placeholder="seleccionar"
          name="propierty"
          id="propierty"
          isDisabled={values.editField}
          value={values.haveVehicle}
          onChange={onChangeInput('haveVehicle')}
        />
      </FormGroup>
    </div>
    {
      ((values.haveVehicle) && (values.haveVehicle.value === true)) && (
        <div >
          <FormGroup>
            <Label className="label_autofin" for="profile">*Patente</Label>
            <Input
              className="mb-2 newArea"
              disabled={values.editField}
              onChange={onChangeInput('carPatent')}
              value={values?.carPatent || ''}
              placeholder="Patente"
              maxLength="6"
            />
          </FormGroup>
        </div>
      )
    }
  </div>
);

export default PersonalData;